/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import useContactService from 'domain/sales/contact/shared/contactService';
import ContactForm from 'domain/sales/contact/createupdate/ContactForm';
import { CreateForm } from 'framework/form';
import CreateContactBreadcrumbs from 'domain/sales/contact/createupdate/Create/Breadcrumbs';
import { useRelatedRedirect, useSearchParameter } from 'framework/routing';
import useErrorMap from 'domain/sales/contact/createupdate/errorHandlers';
import { useContactUrl } from 'domain/sales/contact/contactRouting';
import useAccountUrl from 'domain/sales/account/useAccountUrl';

const CreateContact = () => {
  const { create, getValidationSchema } = useContactService();
  const { getRelatedContactsUrl } = useAccountUrl();
  const { getListUrl } = useContactUrl();
  const { errorsMap } = useErrorMap();
  const accountId = useSearchParameter('accountId');
  const accountName = useSearchParameter('accountName');

  const { redirect } = useRelatedRedirect({
    message: 'You are awesome! The Contact has been successfully created.',
    changedUrl: getListUrl(),
    unchangedUrl: getRelatedContactsUrl(accountId!),
    fields: {
      accountId,
    },
  });

  return (
    <CreateForm
      submitFormFunc={create}
      initialData={{
        accountId,
        accountName,
        address: {
          country: 'United States',
        },
        emails: [],
      }}
      afterSubmit={{
        execute: redirect,
      }}
      getValidationSchemaFunc={getValidationSchema}
      errorsMap={errorsMap}
    >
      <CreatePageLayout title="Create: Contact" breadcrumbs={<CreateContactBreadcrumbs />}>
        <ContactForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateContact;
